import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import NumberInput from '../../../../../../common/inputs/numberInput/NumberInput'
import { parseNumber } from '../../../../../../../services/validation/rules/validationFunctions'
import { formatNumber } from '../../../../../../../i18next/decimal'

const WebViewParkingSpaceRent: React.FC<FieldProps<OtherFacilitiesScreenValidationResult>> = ({
  insertionData,
  validationMessages,
  screenName,
  onChange,
  wrapperClassName = 'grid-item one-whole',
}) => {
  const { t } = useTranslation()

  return (
    <div className={wrapperClassName}>
      <NumberInput
        id='mobile-parking-space-rent'
        propertyName='parkingSpaceRent'
        placeholder=''
        label={<span>{t('wizard.screen.otherFacilities.webViewParkingSpace.rent.label')}</span>}
        value={insertionData.parkingSpaceRent ? parseNumber(insertionData.parkingSpaceRent) : undefined}
        minPrecision={0}
        maxPrecision={2}
        maxLength={14}
        affixRight='unit'
        unitRight='eur'
        style={{}}
        errors={validationMessages?.parkingSpaceRent ?? []}
        doOnFieldChange={(property, value) => {
          onChange({ screen: screenName, property }, formatNumber(value))
        }}
      />
    </div>
  )
}

export default WebViewParkingSpaceRent
